/**
 * URL utilities for external redirects
 */

// Default to staging environment, can be overridden by environment variable
export const EXTERNAL_APP_URL = import.meta.env.VITE_EXTERNAL_APP_URL || 'https://app-dev.tomopiia.net';
// 対話ルームのアプリ（Web）のURL生成
export const getExternalTalkRoomUrl = (talkRoomId: number | string): string => {
  return `${EXTERNAL_APP_URL}/nurse/talkRooms/${talkRoomId}?viewedAs=nurse`;
};
// 研修ルームのアプリ（Web）のURL生成
export const getExternalWorkshopRoomUrl = (workshopRoomId: number | string): string => {
  return `${EXTERNAL_APP_URL}/nurse/workshopRooms/${workshopRoomId}?viewedAs=nurse`;
};
// 上席相談ルームのアプリ（Web）のURL生成
export const getExternalSeniorTalkRoomUrl = (seniorTalkRoomId: number | string): string => {
  return `${EXTERNAL_APP_URL}/nurse/seniorTalkRooms/${seniorTalkRoomId}`;
};
// 運営相談ルームのアプリ（Web）のURL生成
export const getExternalAdminTalkRoomUrl = (adminTalkRoomId: number | string): string => {
  return `${EXTERNAL_APP_URL}/nurse/adminTalkRooms/${adminTalkRoomId}`;
};
// 患者詳細ページのアプリ（Web）のURL生成
export const getExternalPatientUrl = (patientId: number | string): string => {
  return `${EXTERNAL_APP_URL}/nurse/patients/${patientId}`;
};
// 看護師詳細ページのアプリ（Web）のURL生成
export const getExternalNurseUrl = (nurseId: number | string): string => {
  return `${EXTERNAL_APP_URL}/nurse/nurses/${nurseId}`;
};
